// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"16f36ca5","940":"ebbccbc5"}[chunkId] + ".chunk.css";
};